module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/noGamesIcons/noGames/nfl/survive_wt-2ff8f2bdf588462df663017e5db48926.svg";